import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashed = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14 1.86667C13.3884 1.86667 12.8532 1.90707 12.384 1.97937L12.0582 0.137627C12.6497 0.0465067 13.295 0 14 0V1.86667ZM9.77374 3.12252C9.1168 3.74549 8.71496 4.59294 8.39196 5.64345L6.46956 5.12855C6.82493 3.97276 7.34193 2.76748 8.34832 1.81312L9.77374 3.12252ZM7.53044 8.87145C7.17507 10.0272 6.65807 11.2325 5.65168 12.1869L4.22627 10.8775C4.8832 10.2545 5.28504 9.40706 5.60804 8.35655L7.53044 8.87145ZM1.94177 13.8624C1.35034 13.9535 0.70499 14 0 14V12.1333C0.611613 12.1333 1.14677 12.0929 1.61604 12.0206L1.94177 13.8624Z"
	})
});
export default SvgDashed;
